//  ----------------------------------------------------------------------------
//  Dependencies
//  ----------------------------------------------------------------------------
import { apis } from 'utils/lib/apis';
//  -- Actions ------------------------
import * as ActivityActions from './actions';
import { logToSentry } from "utils/networkErrorUtils";
import { handleListUserClasses } from 'store/userClasses/thunks';

//  -- Constants ----------------------
export const handleSetSchoologyAuth = (schoologyUid) => {
    return async (dispatch) => {
        try {
            const response = await apis.get("schoologyRDS", `/schoology/${schoologyUid}`)
            dispatch(ActivityActions.createSchoologyAuth(response));
            if (!response || !response.oauth_token) {
                return false;
            } else {
                return true;
            }
        } catch (error) {
            if(error&&error.message!="Network Error"){
                logToSentry({
                message: 'setting schoology auth',
                error,
                module: 'SCHOOLOGY',
                operation: 'SET_STUDENT_ACTIVITY'
            });
             }
            return false;
        }
    }
}
export const handleCreateSchoologyAuth = (data) => {
    return async (dispatch) => {
        try {
            await apis.post("schoologyRDS", `/schoology`, { body: data })
            dispatch(ActivityActions.createSchoologyAuth(data));
            return true;
        } catch (error) {
            if(error&&error.message!="Network Error"){
                logToSentry({
                message: 'creating schoology auth',
                error,
                module: 'SCHOOLOGY',
                operation: 'CREATE_STORY_AI'
            });
             }
            return false;
        }
    }
}
export const handleSchoologyLogin = async (data) => {
    try {
        return await apis.post("schoologyRDS", `/loginHandler`,{
            body:data
        })
    } catch (error) {
        if(error&&error.message!="Network Error"){
            logToSentry({
                message: 'schoology login',
                error,
                module: 'SCHOOLOGY',
                operation: 'SET_LESSON'
            });
         }
        return null;
    }
}
export const handleSyncSchoologyClasses = async (uid) => {
    try {
        return await apis.get("schoologyRDS", `/syncClassesAndBook/${uid}`)
    } catch (error) {
        if(error&&error.message!="Network Error"){
            logToSentry({
                message: 'syncing schoology classes',
                error,
                module: 'SCHOOLOGY',
                operation: 'SET_STUDENT_CLASS'
            });
         }
        return null;
    }
}
export const handleSyncSchoologyClassesUsers = async (uid,classId) => {
    try {
        return await apis.get("schoologyRDS", `/syncClassUsers/${uid}/${classId}`)
    } catch (error) {
        if(error&&error.message!="Network Error"){
            logToSentry({
                message: 'syncing schoology classes users',
                error,
                module: 'SCHOOLOGY',
                operation: 'SET_STUDENT_CLASS_USER'
            });
         }
        return null;
    }
}
export const handleSyncSchoologyClassesGrades = async (userId,classId) => {
    try {
        return await apis.post("schoologyRDS", `/grade_sync`,{
            body:{
                "classId":classId,
                "userId":userId
            }
        })
    } catch (error) {
        if(error&&error.message!="Network Error"){
            logToSentry({
                message: 'syncing schoology classes grades',
                error,
                module: 'SCHOOLOGY',
                operation: 'SET_STUDENT_CLASS_GROUP'
            });
         }
        return null;
    }
}
export const handleSyncGradesToSchoology = async (teacherId,classId) => {
    try {
        return await apis.post("schoologyRDS", `/sync_grade_complete_class`,{
            body:{
                "classId":classId,
                "teacherId":teacherId
            }
        })
    } catch (error) {
        if(error&&error.message!="Network Error"){
            logToSentry({
                message: 'syncing grades to schoology',
                error,
                module: 'SCHOOLOGY',
                operation: 'SET_GROUP_TEACHER_STUDENT'
            });
         }
        return null;
    }
}
export const handleSyncAssignmentDataSchoology = async (classId,schoologyid) => {
    try {
        return await apis.get("schoologyRDS", `/syncClassAssignment/${schoologyid}/${classId}`)
    } catch (error) {
        if(error&&error.message!="Network Error"){
            logToSentry({
                message: 'syncing assignment data schoology',
                error,
                module: 'SCHOOLOGY',
                operation: 'SET_ACTIVITY_DATA_STUDENT'
            });
         }
        return null;
    }
}

export const handleDeleteSchoologyAssignment = async (schoologyid, activityId, classAssignmentId) => {
    try {
        return await apis.post("schoologyRDS", `/deleteAssignment`,{
            body:{
                schoologyid, activityId, classAssignmentId
            }
        })
    } catch (error) {
        if(error&&error.message!="Network Error"){
            logToSentry({
                message: 'deleting schoology assignment',
                error,
                module: 'SCHOOLOGY',
                operation: 'DELETE_STORY_AI'
            });
         }
        return null;
    }
}

// export const handleGradeToSchoology = async (data) => {
//     try {
//         const response = await API.post("schoologyRDS", `/update_grade`, {
//             body: data
//         })
//         return response;
//     } catch (error) {
//         if (error && error.message != "Network Error") {
//             logToSentry({
            //     message: 'Error in operation',
            //     error,
            //     module: 'SCHOOLOGY',
            //     operation: 'SET_SCHOOLOGY_AUTH'
            // })
//         }
//         console.log("error in updating grades")
//         return null;
//     }
// }
let gradeQueue = []; // Queue to collect data from multiple calls
let debounceTimer = null; // Timer for the 10-second interval

export const handleGradeToSchoology = async (data,instant=false) => {
    return new Promise((resolve) => {
        if (!data?.sAssignmentId) {
            resolve(null);
            return;
        }

        const hasValueIndex = data && data.sAssignmentId ? gradeQueue.findIndex(k => k.sectionId == data.sectionId && k.sAssignmentId == data.sAssignmentId && k.studentSchoologyIds[0] == data.studentSchoologyIds[0]) : -1;
        if (hasValueIndex > -1) {
            gradeQueue[hasValueIndex] = data;
        } else {
            gradeQueue.push(data);
        }

        const flushQueue = async () => {
            try {
                if (!gradeQueue.length) {
                    resolve(null);
                    return null;
                }

                const latest = gradeQueue[gradeQueue.length - 1];
                const combinedData = {
                    sectionId: gradeQueue[0].sectionId,
                    schoologyid: gradeQueue[0].schoologyid,
                    manualGrading: latest.manualGrading,
                    feedbackText: latest.feedbackText,
                    studentSchoologyIds: gradeQueue.map((item) => ({
                        schoologyid: item.studentSchoologyIds[0],
                        grade: item.value,
                        sAssignmentId: item.sAssignmentId,
                        statusCode: item.statusCode
                    })),
                };

                gradeQueue = [];

                const response = await apis.post("schoologyRDS", `/update_grade`, {
                    body: combinedData
                });

                resolve(response);
                return response;
            } catch (error) {
                if (error && error.message !== "Network Error") {
                    logToSentry({
                        message: 'updating grades',
                        error,
                        module: 'SCHOOLOGY',
                        operation: 'UPDATE_GROUP'
                    });
                }
                resolve(null);
                return null;
            }
        };

        if (instant) {
            if (debounceTimer) {
                clearTimeout(debounceTimer);
                debounceTimer = null;
            }
            void flushQueue();
            return;
        }

        if (debounceTimer) {
            clearTimeout(debounceTimer);
        }

        debounceTimer = setTimeout(async () => {
            await flushQueue();
        }, 3000); // 4-second interval
    });
};
export const handleSyncGradeToSchoologyFormOwe = async (data) => {
    try {
        const response = await apis.post("schoologyRDS", `/syncGradesToSchoology`, {
            body: data
        })
        return response;
    } catch (error) {
        if (error && error.message != "Network Error") {
            logToSentry({
                message: 'syncing grade to schoology form owe',
                error,
                module: 'SCHOOLOGY',
                operation: 'SET_GROUP_TEACHER_STUDENT_FEEDBACK_ORGANIZATION'
            });
        }
        console.log("error in updating grades")
        return null;
    }
}
export const handleSyncGradeToSchoologyByAssignment = async (schoologyid, assignment_id) => {
    try {
        const response = await apis.post("schoologyRDS", `/sync_assignment_grade_to_schoology`, {
            body: {
                schoologyid, assignment_id
            }
        })
        return response;
    } catch (error) {
        if (error && error.message != "Network Error") {
            logToSentry({
                message: 'syncing grade to schoology by assignment',
                error,
                module: 'SCHOOLOGY',
                operation: 'SET_GROUP_TEACHER_STUDENT_BOOK_ACTIVITY'
            });
        }
        console.log("error in updating grades")
        return null;
    }
}
export const handleSyncGradeFromSchoologyByAssignment = async (schoologyid, assignment_id) => {
    try {
        const response = await apis.post("schoologyRDS", `/sync_assignment_grade_from_schoology`, {
            body: {
                schoologyid, assignment_id
            }
        })
        return response;
    } catch (error) {
        if (error && error.message != "Network Error") {
            logToSentry({
                message: 'syncing grade from schoology by assignment',
                error,
                module: 'SCHOOLOGY',
                operation: 'SET_GROUP_FEEDBACK_STUDENT_BOOK_ACTIVITY'
            });
        }
        console.log("error in updating grades")
        return null;
    }
}
export const handleFetchSchoologyUserInfo = async (user_id) => {
    try {
        const response = await apis.post("schoologyRDS", `/fetchUserInfo`, {
            body: {
                user_id:user_id
            }
        })
        return response;
    } catch (error) {
        if (error && error.message != "Network Error") {
            logToSentry({
                message: 'fetching schoology user info',
                error,
                module: 'SCHOOLOGY',
                operation: 'FETCH_STUDENT_USER_INSTRUCTION'
            });
        }
        console.log("error in updating grades")
        return null;
    }
}
export const handleCreateAssignmentToSchoology = async (schoologyid,assignment_data) => {
    if(!schoologyid) return [];
    try {
        const timezoneName = typeof Intl !== 'undefined' && Intl.DateTimeFormat
            ? Intl.DateTimeFormat().resolvedOptions().timeZone
            : undefined;
        const response = await apis.post("schoologyRDS", `/createAssignments`, {
            body: {
                schoologyid,
                assignment_data,
                ...(timezoneName && { timezone_name: timezoneName })
            }
        })
        if(response&&response.success) {
            return response.data
        }else {
            return [];
        }
    } catch (error) {
        if (error && error.message != "Network Error") {
            logToSentry({
                message: 'creating assignment to schoology',
                error,
                module: 'SCHOOLOGY',
                operation: 'CREATE_ACTIVITY_TEACHER_STUDENT'
            });
        }
        console.log("error in updating grades")
        return [];
    }
}
export const handleFetchSchoologyCourses = async (schoologyId) => {
    try {
        const response = await apis.post("schoologyRDS", `/schoology/sections/list`,{
            body:{
                schoologyId
            }
        })
        return response;
    } catch (error) {
        if (error && error.message != "Network Error") {
            logToSentry({
                message: 'fetching schoology courses',
                error,
                module: 'SCHOOLOGY',
                operation: 'FETCH_STUDENT_CLASS'
            });
        }
        return {error:true,message:error.message};
    }
}

export const handleSyncSchoologyClass = (schoologyId, section,currentUser) => async dispatch => {
    try {
        const response = await apis.post("schoologyRDS", `/schoology/sections/create`, {
            body: {
                schoologyId,
                section
            }
        })
        if(response&&response.success) {
           await dispatch(handleListUserClasses(currentUser.id));
        }
        return response;
    } catch (error) {
        if (error && error.message != "Network Error") {
            logToSentry({
                message: 'syncing schoology class',
                error,
                module: 'SCHOOLOGY',
                operation: 'SET_STUDENT_CLASS'
            });
        }
        console.log("error in syncing schoology class")
        return {error:true,message:error.message};
    }
}